import { connect } from 'react-redux';

import { setShowLeftMenu, setDarkMode, setConsideredMedium, setConsideredMobile } from '../state/actions';

import WindowStateManager from '../components/WindowStateManager';

const mapStateToProps = (state) => ({
    showLeftMenu: state.showLeftMenu,
    darkMode: state.darkMode,
    isConsideredMobile: state.isConsideredMobile,
})
  
const mapDispatchToProps = {
    setShowLeftMenu,
    setDarkMode,
    setConsideredMedium,
    setConsideredMobile,
}
  
const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(WindowStateManager)